import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';
import { authenticatedGuard, dashboardRedirectGuard, notAuthenticatedGuard } from './common/auth';
import { provideMatomo, withRouter } from 'ngx-matomo-client';
import { WaitingComponent } from './common/auth/waiting.component';
import { GenericSettingService, ReportService } from './common';
import { ArchiveComponent } from './company/archive/archive.component';
import { AppMode } from './common/app-state';
import { NotFoundComponent } from './not-found.component';
import { NewsletterUnsubscribeComponent } from './common/auth/newsletter-unsubscribe.component';
import { WikiRedirectComponent } from './common/wiki-redirect.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authenticatedGuard, dashboardRedirectGuard],
    loadChildren: () => import('./dashboard'),
  },
  { path: '', canActivate: [notAuthenticatedGuard], loadChildren: () => import('./common/auth') },
  { path: 'newsletter/unsubscribe', component: NewsletterUnsubscribeComponent },
  { path: 'wiki', component: WikiRedirectComponent },
  {
    path: 'waiting',
    component: WaitingComponent,
    resolve: {
      adminAvailable: async () => (await inject(GenericSettingService).getAdminAvailability())?.value === 'online',
    },
  },
  {
    path: 'a/:archiveId',
    canActivate: [authenticatedGuard],
    component: ArchiveComponent,
    resolve: {
      list: async (route: ActivatedRouteSnapshot) => ({
        totalElements: 1,
        content: [await inject(ReportService).detailArchive(route.params[`archiveId`])],
      }),
    },
    data: { openFirstDocument: true },
  },
  {
    path: 'help',
    canActivate: [authenticatedGuard],
    loadChildren: () => import('./help'),
    data: { mode: AppMode.HELP },
  },
  { path: 'invite', canActivate: [authenticatedGuard], loadChildren: () => import('./invite') },
  { path: 'user', canActivate: [authenticatedGuard], loadChildren: () => import('./user') },
  { path: 'team', canActivate: [authenticatedGuard], loadChildren: () => import('./team') },
  { path: 'company', canActivate: [authenticatedGuard], loadChildren: () => import('./company') },
  {
    path: 'admin',
    canActivate: [authenticatedGuard],
    loadChildren: () => import('./admin'),
    data: { mode: AppMode.EXTRA_WIDE },
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'top', // or disable
      anchorScrolling: 'disabled',
    }),
  ],
  providers: [
    provideMatomo(
      {
        acceptDoNotTrack: false,
        trackerUrl: '/api/',
        trackerUrlSuffix: 'stats',
        scriptUrl: '/api/stats',
        enableJSErrorTracking: true,
        siteId: 7,
      },
      withRouter()
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
